export default __webpack_public_path__ + "static/media/DITLoginLeft.8b46bd9d.png";